import angular from "angular";
import dcStudentFooterNav from "./student-footer-nav.directive";
import dcStudentFooterNavController from "./student-footer-nav.controller";
export default angular
  .module("student.directives.footernav", [])
  .controller("dcStudentFooterNavController", dcStudentFooterNavController)
  .directive("dcStudentFooterNav", dcStudentFooterNav);
